module.exports = __webpack_public_path__ + "static/mobile-a54246d863d469485d1a7b58cfe799ca.jpg";